import styled from 'styled-components';

export const StyledIframe = styled.iframe`
    width: 100%;
    min-height: 80vh;
    border: none;
    margin: 0;
    padding: 16px;
    display: flex;
`;
